import {
  List,
  Datagrid,
  TextField,
  ResourceComponentProps,
  TextInput,
  Show,
  SimpleShowLayout,
} from "react-admin";

const PerkListFilters = [
  <TextInput source="id" />,
  <TextInput source="name" />,
];

export const PerkList = (props: ResourceComponentProps) => (
  <List {...props} bulkActionButtons={false} filters={PerkListFilters}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
    </Datagrid>
  </List>
);


export const PerkShow = (props: ResourceComponentProps) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="salesforceId" />
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
);

